import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
      data-testid='icon_file-plus'
    >
      <path
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='M9.333 1.334H4a1.333 1.333 0 00-1.333 1.333v10.667A1.333 1.333 0 004 14.667h8a1.333 1.333 0 001.333-1.333v-8l-4-4zM8 12V8M6 10h4'
      />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='M9.334 1.334v4h4' />
    </svg>
  );
}

export default Icon;
